import { http } from '../config/config-receituario'

function getHeaders(token, key) {
  const headers = {
    Authorization: token,
  }

  if (key) {
    headers.key = key
  }

  return headers
}

export default {
  listar: (token, key, params = {}) => {
    return http.get('defesas', {
      headers: getHeaders(token, key),
      params,
    })
  },
  findById: (token, key, id) => {
    return http.get(`defesas/${id}`, {
      headers: getHeaders(token, key),
    })
  },
  salvar: (token, key, defesa) => {
    return http.post('defesas', defesa, {
      headers: getHeaders(token, key),
    })
  },
  update: (token, key, defesa) => {
    return http.put(`defesas/${defesa.id_defesa}`, defesa, {
      headers: getHeaders(token, key),
    })
  },
  deletar: (token, key, id) => {
    return http.delete(`defesas/${id}`, {
      headers: getHeaders(token, key),
    })
  },
}
